module.exports = __webpack_public_path__ + "static/img/jrj2.9d82ba6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/newsDetail/images/jrj2.jpg
// module id = sA4G
// module chunks = 0